var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('next-steps-base-card',{attrs:{"title":"להחליט כמה אפשר להעביר לחסכונות וכמה כדאי להשאיר בעו״ש","button-text":"למחשבון העו״ש","description":"2 דקות, מחשבון","action-key":_vm.actionKey},on:{"click":_vm.openBalanceMoneyCalculator}})}
var staticRenderFns = []

export { render, staticRenderFns }